var inherit = require("../general.js").inherit;
var mixin = require("../general.js").mixin;

var Root = require("./root.js");
var GlobalUid = require("./globalUid.js");
var LocalUid = require("./localUid.js");
var JsonParser = require("./jsonParser.js");
var Undoable = require("./undoable.js");
//var Shareable = require("./shareable.js");
var Hashifier = require("./hashifier.js");

var HeavyHandler = require("./../../heavyHandler.js");

// General root for persistent data: gives each node a globally unique id, is undoable and shareable
var DataRoot = function () {
    Root.call(this);

    this.initGlobalUid();
    this.initLocalUid();
    this.initJsonParser();
    this.makeUndoable();
    //this.makeShareable();

    this.hasUnsavedChanges = false;
    this.changeSaveStateHandlers = {};

    this.heavyHandler = new HeavyHandler();
    this.onFinishAction("heavyHandler", function (action, remote) {
        this.heavyHandler.runAllHeavies();
        this.wasChanged();
    });
};
inherit(DataRoot, Root);
mixin(DataRoot, GlobalUid, LocalUid, JsonParser, Undoable, Hashifier);

DataRoot.prototype.onChangeSaveState = function(id, handler){
    this.changeSaveStateHandlers[id] = handler;
}

DataRoot.prototype.removeChangeSaveStateHandler = function(id){
    delete this.changeSaveStateHandlers[id];
}

DataRoot.prototype.wasSaved = function(){
    if(this.hasUnsavedChanges){
        this.hasUnsavedChanges = false;
        this.triggerSaveStateChangeHandlers();
    }
}

DataRoot.prototype.wasChanged = function(){
    if(!this.hasUnsavedChanges){
        this.hasUnsavedChanges = true;
        this.triggerSaveStateChangeHandlers();
    }
}

DataRoot.prototype.triggerSaveStateChangeHandlers = function(val){
    for(var key in this.changeSaveStateHandlers){
        if(this.changeSaveStateHandlers.hasOwnProperty(key)){
            this.changeSaveStateHandlers[key](this.hasUnsavedChanges);
        }
    }
}


module.exports = DataRoot;
